<template>
  <Transition name="fade">
    <div v-if="isVisible" class="modal-center">

      <div class="modal-content">
        <div class="modalheader">
          <h2 v-if="!editMode">{{$t('add_new_tag')}}</h2>
          <h2 v-else>{{$t('edit_tag')}}</h2>

          <div @click="onClose" class="close-btn">
            <img class="cross" src="@/assets/images/cross.svg" />
          </div>
        </div>
        <div class="modalbody">

          <input class="form-input" :placeholder="this.$t('tag_name')" v-model="tagData.name">

          <div class="tag-type-selector" v-click-outside="() => typeDropdownVisible = false">
            <div class="tag-type-trigger" @click="typeDropdownVisible = !typeDropdownVisible">
              <span v-if="!tagData.color" class="placeholder">{{$t('tag_type')}}</span>
              <span v-else class="category-tag" :class="tagData.color">{{ getTagTypeLabel(tagData.color) }}</span>
              <img src="@/assets/images/arrowdown.svg" />
            </div>
            <div v-if="typeDropdownVisible" class="tag-type-dropdown">
              <div
                v-for="type in tagTypes"
                :key="type.value"
                class="tag-type-option"
                :class="{ selected: tagData.color === type.value }"
                @click="handleTypeSelect(type.value)"
              >
                <span class="category-tag" :class="type.value">{{ getTagTypeLabel(type.value) }}</span>
              </div>
            </div>
          </div>
          <div class="status-row">
            <span class="status-text">{{$t('status')}}</span>
            <Switch v-model="tagData.status" />
          </div>

          <div class="action-row">
            <button class="dark-button" @click="onAction">
              <span v-if="!loading && !editMode">{{$t('add_tag')}}</span>
              <span v-if="!loading && editMode">{{$t('update_tag')}}</span>
              <VueSpinnerIos v-if="loading" size="20" height="100%" color="#fff" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import {
  VueSpinnerIos
} from 'vue3-spinners'
import tagService from "@/service/tagService";
import {handleErrorResponse} from "@/utils/utils";
import Switch from "@/components/Switch.vue";

export default {
  components: {
    Switch,
    VueSpinnerIos
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    editMode: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: {
        tagId: "",
        name: "",
        color: "primary",
        status: true,
      }
    },
    refreshCallback: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      typeDropdownVisible: false,
      tagTypes: [
        {
          value: "primary",
          text: "Primary"
        },
        {
          value: "warning",
          text: "Warning"
        },
        {
          value: "success",
          text: "Success"
        },
        {
          value: "danger",
          text: "Danger"
        }
      ],
      tagData: {
        name: "",
        color: "primary",
        status: true,
      }
    }
  },
  methods: {
    handleTypeSelect(value) {
      this.tagData.color = value;
      this.typeDropdownVisible = false;
    },
    getTagTypeLabel(value) {
      return this.$t('tag_type_' + value);
    },
    onAction() {
      if (this.editMode) {
        this.handleEditTag();
      } else {
        this.handleAddTag();
      }
    },
    handleAddTag() {
      if (!this.tagData.name || this.loading) {
        return;
      }

      this.loading = true;
      tagService.addTag(this.tagData).then(response => {
        this.loading = false;
        this.$snackbar.add({
          text: this.$t('tag_added_success'),
          type: "success"
        });
        this.tagData = {
          name: "",
          color: "primary",
          status: true,
        };
        this.refreshCallback();
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar);
        this.loading = false;
      })
    },
    handleEditTag() {
      if (!this.tagData.tagId || !this.tagData.name || this.loading) {
        return;
      }

      this.loading = true;
      tagService.updateTag(this.tagData).then(response => {
        this.loading = false;
        this.$snackbar.add({
          text: this.$t('tag_updated_success'),
          type: "success"
        });
        this.refreshCallback();
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar);
        this.loading = false;
      })
    }
  },
  watch: {
    editData: {
      handler: function (val) {
        if (this.editMode) {
          this.tagData = val;
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 20px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:12px
}

.modalheader {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.modalheader h2 {
  color: #040C2D;
  text-align: left;
  font-family: euclid_medium, sans-serif;
  font-size: 20px;
  font-style: normal;
  line-height: 24px;
}

.close-btn {
  height: 24px;
  width: 24px;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cross{
  height: 10px !important;
  width: 10px !important;
}

.modalbody {
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.modalbody p {
  color: #667085;
  text-align: center;
  align-items: center;
  font-family: euclid_regular, sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
}


.modalbutton span {
  color: #FFF;
  text-align: center;
  font-family: euclid_regular, sans-serif;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}

.modalbutton.cancel span {
  color: #667085;
  text-align: center;
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}

.action-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}

.status-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  justify-content: flex-start;
}

.status-text {
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  color: #040C2D;
}

.form-input, .select-box {
  width: 100%;
}

.tag-type-selector {
  position: relative;
  width: 100%;
}

.tag-type-trigger {
  border-radius: 8px;
  border: 1px solid #F5F5F5;
  background: #F5F5F5;
  padding: 12px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: 100%;
}

.tag-type-trigger .placeholder {
  font-size: 14px;
  font-family: 'euclid_regular', sans-serif;
  color: #717171;
}

.tag-type-trigger img {
  width: 16px;
  height: 16px;
}

.tag-type-dropdown {
  position: absolute;
  top: calc(100% + 5px);
  left: 0;
  right: 0;
  border: 1px solid #EAECF0;
  background: #fff;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 99999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.tag-type-option {
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.tag-type-option:hover {
  background-color: #F5F7FA;
}

.tag-type-option.selected {
  background-color: #F0F2FF;
}

.category-tag {
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-family: 'euclid_medium', sans-serif;
  display: inline-block;
}

.category-tag.primary {
  background-color: #4A68F8;
  color: #FFF;
}

.category-tag.warning {
  background-color: #FF8E55;
  color: #FFF;
}

.category-tag.danger {
  background-color: #FF5B5B;
  color: #FFF;
}

.category-tag.success {
  background-color: #00D68F;
  color: #FFF;
}

</style>
